import $ from "jquery";
import {Modal} from "bootstrap";

export const init = () => {
  let modalElementList = document.querySelectorAll(".modal");
  [...modalElementList].map((modal) => new Modal(modal));

  let standardModal = document.getElementById("standard-modal");
  standardModal.addEventListener("show.bs.modal", (event) => {
    // Button that triggered the modal
    let link = $(event.relatedTarget);

    // Extract info from data-* attributes
    let ajaxUrl = link.data("url");
    $.ajax({
      url: ajaxUrl,
      context: document.body,
    })
      .done(function (data) {
        $("#standard-modal-content").html(data);
      })
      .fail(function () {
        console.warn("Error. Couldn't get data from server.");
      });
  });
};
